//YUI
export type YUIContext = any;

export type bulmaCollapsible = any;

//declare namespace PDFLib { }

/*declare class PDFDocument {
    static create(): any;
    //embedFont(font: any): void;
}*/


//Callbacks
export type BabylonActionCallback = (e: BABYLON.ActionEvent) => any;
export type EntityCreateCallback = (entity: Entity, WentityNode: BABYLON.AbstractMesh | BABYLON.Mesh | BABYLON.TransformNode, productNumber: string) => any;
export type ModuleCreateCallback = (module: Module, moduleNode: BABYLON.TransformNode) => any;

//Events
export type ConnectorClickHandler = (e: BABYLON.PickingInfo) => any;

//Enums
export enum ConnectorType {
    LEFT = 1,
    RIGHT = 2,
    PILLOW = 4
}

export enum MeshVisibility {
    VISIBLE = 1,
    HIDDEN = 2,
    FADED = 4,
    HIGHLIGHTED = 8
}

export enum PROJECT_STATE {
    ACTIVE = 1,
    ORDERED = 2,
    INACTIVE = 4
}
export enum OptionType {
    CONTAINER = "container",
    OPTION = "option"
}

//Interfaces

export interface User {
    name: string,
    role: number
}

export interface LoadedMeshState {
    identifier: string,
    flipped: boolean,
    category: string,
    state: string
}

export interface Model {
    product: Product,
    root: BABYLON.TransformNode
}

export interface Series {
    id: number,
    SeriesItemNumber: string;
    name: string,
    thumbnail: string,
}

export interface SeriesData {
    id: number,
    name: string,   
    categories: Array<string>,
    thumbnail: string,
    materials: Array<Material>,      
    defaultMaterial: string,
    presets: Array<Preset>,
    legPackages: Array<LegPackage>,
    accessories: Accessory[],
    customOptions: CustomOptionGroup[]
}

export interface Accessory {
    name: string;
    description: string;
    accessoryGroup: string;
    itemType: string;
    productNumber: string;
    priceLists: ProductPriceList[];
}

export interface CustomOptionGroup {
    name: string;
    id: string;
    perModule: boolean;
    options: CustomOption[];
}

export interface CustomOption {
    name: string;
    id: string;
    PricePer: string;
    ProductType: string;
    priceLists: CustomOptionPrice[];
}

export interface CustomOptionPrice {
    name: string;
    pricePer: string;
    productNumber: string;
    items: string[];
    priceLists: ProductPrice[];
    productType: string;
}

export interface LegPackage {
    legs: Array<Leg>
    type: string,
    surface: string,
    height: number,
}

export interface Leg {
    id: number,
    model: string,
    name: string,
    productNumber: string,
    thumbnail: string,
    legShapeSize: any,
    legRotation: number,
    legOffsetFromFront: number,
    legOffsetFromSide: number,
    type: LegType,
    surface: string,
    height: number,
}

export interface LegType {
    name: string,
    identifier: string
}

export interface LegVariant {
    id: number,
    productNumber: string,
    color: string,
    material: string,
    height: number,
    width: number,
    depth: number,
    type: string,
    thumbnail: string,
    types: string[]
}

export interface Preset {
    id: string,
    name: string,
    config: string,
    thumbnail: string
}

export interface Metrics {
    bounds: BABYLON.BoundingInfo,
    dimensions: Object
}

export interface ProductCategory {
    id: number,
    name: string,
    model: string,
    type: string,
    productType: string,
    products: Product[]
}

export interface Product {
    id: number,
    name: string,
    model: string,
    productNo: string,
    axProductNo: string,
    series: number,
    perfionIdentifier: string,
    categories: Array<string>,
    width: number,
    height: number,
    depth: number,
    type: string,
    isFlipped: boolean,
    isClosing: boolean,
    isComplete: boolean,
    thumbnail: string,  
    connectors: Connector[],
    cushionPackages: CushionPackage[]      
}

export interface Variant {
    name: string,
    productNumber: string
}

export interface CushionPackage {
    isDefault: boolean,
    name: string,
    variants: CushionPackageVariant[]
}

export interface CushionPackageItem {
    name: string,
    quantity: number
}

export interface CushionPackageVariant {
    name: string,
    connectionType: string,
    productNo: string,
    axProductNo: string,
    isFlipped: boolean,
    model: string,
    legPackageID: string,
    pricelists: ProductPriceList[],
    legs: ProductLeg[],
    recommendedCushions: CushionPackageItem[],
}

export interface ProductLeg {
    type: string,
    amount: string,
}

export interface ProductPriceList {
    currency: string,
    name: string,
    prices: Price[];
}

export interface ProductPrice {
    currency: string,
    name: string,
    price: number;
}

export interface Price {
    [s: string]: number;
}

export interface Texture {
    id: string,
    name: string,
    blobUrl: string
}

export interface Material {
    id: string,
    name: string,
    productNumber: string,
    type: string,
    group: string,
    //folderName?: string,
    priceGroup: string,
    rollWidth: number,
    properties: {
        metalness: number,
        roughness: number,
        sheen: number,
        detailbump: number,
        ao: number,
        tileU: number,
        tileV: number
    },   
}

export interface MaterialFilter {
    key: string,
    value: string
}

export interface Attachment {
    type: string,   
    position: BABYLON.Vector3,
    rotation: BABYLON.Vector3
}

export interface Connector {
    id: string,   
    position: BABYLON.Vector3,
    rotation: BABYLON.Vector3
}

export interface ApiProject {
    added: Date,
    modified: Date,
    identifier: string,
    name: string,
    seller: string,
    phone: string,
    status: number,
    configurations: {series: string; data: string}[];
}

export interface Project {
    added: Date,
    modified: Date,
    identifier: string,
    name: string,
    seller: string,
    phone: string,
    status: number,
    configurations: Array<Configuration>
}

export interface Configuration {
    series: string;
    image?: string;
    drawing?: string;
    data: ConfigurationData;
}

export interface ConfigurationData {
    id: string;
    offsetY: number;
    material: string;
    modules: Module[];
    thumbnail: string;
    options: {[key: string]: string | boolean | number};
    addons?: {productNo: string, amount: number}[];
    customOptions?: {id: string, value: string}[];
}

export interface Module {
    id: any,
    entities: Entity[],
    position: BABYLON.Vector3,
    rotation: BABYLON.Vector3,
    uniqueId: number
}

export interface Entity {
    id: any,
    uniqueId: number,
    parentId: string,
    attachId: string,
    connections: Connection[],
    connectors: Connector[],
    rotation: BABYLON.Vector3,
    position: BABYLON.Vector3,
    category: string,
    type: string,
    variant: string,
    productNo: string,
    variantProductNo: string,
    customOptions?: {id: string, value: string}[];
}

export interface PriceOption {
    id: string,
}

export interface WeightedConnection {
    entity: Entity,
    entityNode: BABYLON.TransformNode,
    connectorNode: BABYLON.TransformNode,
    weight: number
}

export interface Connection {
    id: string,
    entityId: string   
}

export interface ConnectorInfo {
    entityNode: BABYLON.TransformNode | BABYLON.AbstractMesh | BABYLON.Mesh,
    connectorNode: BABYLON.TransformNode | BABYLON.AbstractMesh | BABYLON.Mesh,
    isEnabled: boolean
}

export interface RulerDefinition {
    name: string,
    width: number,
    height: number,
    depth: number,
    offset: number,
    lineColor?: BABYLON.Color3,
    position?: BABYLON.Vector3,
    rotation?: BABYLON.Vector3,
    axis?: string
}

export interface PriceOption {
    id: string,
    name: string,
    dataType: string,       
    thumbnail: string,
    options: Array<PriceOption>
}

export interface ProjectFilter {
    search: string,
    hideInactive: boolean,
    currentPage: number,
    itemsShown: number
}

export interface ModuleSummaryElement { 
    axProductNo: string;
    variantProductNo: string;
    variantName: string;
    productNo: string;
    currency: string;
    price: number;
    legPackageId: string;
    amount: number;
    entity: string;
    extras: {
        name: string;
        optionId: string;
        optionValue: string;
        productNo: string;
        price: number;
    }[];
}

export interface ModuleSummaryAccessory { 
    productNo: string;
    currency: string;
    price: number;
    amount: number;
    extras: {
        name: string;
        optionId: string;
        optionValue: string;
        productNo: string;
        price: number;
    }[];
}

export interface ModuleSummaryCustomOption { 
    name: string;
    productNo: string;
    currency: string;
    totalprice: number;
    amount: number;
}